import Immutable from 'immutable'
import moment from 'moment'

export const StorableCardRecord = Immutable.Record({
  expiry: null,
  name: null,
  number: null,
}, 'StorableCard')

export default function createStorableCard({
  expiry,
  ...data
}) {
  return new StorableCardRecord({
    ...data,
    expiry: expiry ? moment(expiry) : null,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/StorableCard.js